import React from 'react'

export default ({ children, ...props }) => (
  <a
    {...props}
    className="inline-block py-6 mr-8 font-normal text-white hover:text-primary text-base transition-colors duration-150 cursor-pointer"
  >
    {children}
  </a>
)
